import React from 'react';
import { useFormContext } from 'react-hook-form';
import { TextfieldController } from 'src/components/forms/TextfieldController';

interface BillFormNumRefProps {}

export const BillFormNumRef: React.FC<BillFormNumRefProps> = () => {
  const { control } = useFormContext();

  return (
    <TextfieldController
      control={control}
      name="num_ref"
      size="small"
      label="Número de referência"
      rules={{ required: false }}
    />
  );
};

export default BillFormNumRef;
